import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c626d604"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_home_banner = _resolveComponent("home-banner")!
  const _component_home_button = _resolveComponent("home-button")!
  const _component_home_image_slider = _resolveComponent("home-image-slider")!
  const _component_home_row = _resolveComponent("home-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_home_banner, {
      id: "banner",
      "file-name": $options.backgroundPhoto
    }, null, 8, ["file-name"]),
    _createVNode(_component_home_row, { id: "row-1" }, {
      default: _withCtx(() => [
        _createVNode(_component_home_button, {
          "file-name": $options.button1,
          onClick: $options.handleButton1Click
        }, null, 8, ["file-name", "onClick"]),
        _createVNode(_component_home_image_slider)
      ]),
      _: 1
    }),
    _createVNode(_component_home_row, { id: "row-2" }, {
      default: _withCtx(() => [
        _createVNode(_component_home_image_slider),
        _createVNode(_component_home_button, {
          "file-name": $options.button2,
          onClick: $options.handleButton2Click
        }, null, 8, ["file-name", "onClick"])
      ]),
      _: 1
    }),
    _createVNode(_component_home_row, { id: "row-3" }, {
      default: _withCtx(() => [
        _createVNode(_component_home_button, {
          "file-name": $options.button3,
          onClick: $options.handleButton3Click
        }, null, 8, ["file-name", "onClick"]),
        _createVNode(_component_home_button, {
          "file-name": $options.button4,
          onClick: $options.handleButton4Click
        }, null, 8, ["file-name", "onClick"]),
        _createVNode(_component_home_button, {
          "file-name": $options.button5,
          onClick: $options.handleButton5Click
        }, null, 8, ["file-name", "onClick"])
      ]),
      _: 1
    })
  ]))
}